// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Pipeline node for extraction analysis.
 * Accepts text or extractions, outputs extractions.
 */
import { memo } from 'react'
import { Sparkles } from 'lucide-react'

import { BaseNode } from '@/subsystems/pipelines'

export const AnalysisPromptWorkflowNode = memo(() => (
  <BaseNode
    icon={<Sparkles />}
    label="Extraction Analysis"
    hasInput
    hasOutput
  />
))

AnalysisPromptWorkflowNode.displayName = 'AnalysisPromptWorkflowNode'
